import { SankeyDataNode, SankeyNode } from '../types/Sankey';

export const agencyLegendOrder: string[] = ['CAH', 'SPE', 'CNR', 'DPK'];

export function transformMapToShowTop(top: number, map: Map<string, number>): Array<SankeyDataNode> {
  let result: Array<SankeyDataNode> = Array.from(map).map(([k, v]) => ({
    label: k,
    aggregateTotal: v,
    grouped: false
  }));

  result = result.sort((a, b) => b.aggregateTotal - a.aggregateTotal);

  if (top < 0) {
    return result;
  }

  // mark any node greater than the view limit for grouping
  result = result.map((node, index) => {
    return index > top - 1 ? { ...node, grouped: true } : node;
  });

  return result;
}

export function createSankeyViewNodes(dataNodes: Array<SankeyDataNode>, groupedLabel: string): Array<SankeyNode> {
  return dataNodes.filter(n => n.grouped).length
    ? [...dataNodes.filter(n => !n.grouped), { label: groupedLabel }]
    : dataNodes;
}
